"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readErrorArgs = void 0;
const isMessage = (object) => {
    return typeof object === 'string';
};
const isError = (object) => {
    return object instanceof Error;
};
const readErrorArgs = (messageOrError, errorOrArgs, args) => {
    const message = isMessage(messageOrError)
        ? messageOrError
        : messageOrError.message;
    const originalError = isError(errorOrArgs) ? errorOrArgs : undefined;
    const errorArgs = args
        ? args
        : !isError(errorOrArgs)
            ? errorOrArgs
            : undefined;
    return {
        message,
        originalError,
        errorArgs
    };
};
exports.readErrorArgs = readErrorArgs;
